module.exports = __webpack_public_path__ + "img/first-race.2a05a078.png";